import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getIcon } from "@/lib/constants";
import ServiceDemo from "@/components/ServiceDemos";

const ServicesSection = ({ services }) => {
  return (
    <section className="section-padding bg-[#050505]" data-testid="services-section">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#00E676] uppercase tracking-wider text-sm font-medium">Our Services</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
            Complete Digital Marketing Solutions for Dallas Businesses
          </h2>
          <p className="text-gray-400 text-lg">
            From Local SEO to AI-powered AEO and GEO optimization, we have the expertise to grow your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.slice(0, 8).map((service, index) => (
            <Link 
              key={service.id} 
              to={`/services/${service.slug}`}
              className="group flex flex-col rounded-2xl overflow-hidden bg-[#0A0A0A] border border-white/[0.08] hover:border-[#00E676]/30 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,230,118,0.08)]"
              data-testid={`service-card-${service.id}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Animated service demo */}
              <div className="border-b border-white/[0.06]">
                <ServiceDemo slug={service.slug} />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2.5 mb-2">
                  <span className="text-[#00E676] shrink-0 group-hover:scale-110 transition-transform">
                    {getIcon(service.icon, "w-5 h-5")}
                  </span>
                  <h3 className="text-lg font-bold text-white group-hover:text-[#00E676] transition-colors leading-tight">
                    {service.name || service.title}
                  </h3>
                </div>
                <p className="text-gray-400 text-sm line-clamp-2">
                  {service.shortDesc || service.description}
                </p>
                <div className="mt-auto pt-4 flex items-center gap-2 text-[#00E676] text-sm font-medium">
                  Learn More <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/services">
            <Button className="btn-outline" data-testid="view-all-services">
              View All Services
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
